<template>
  <main-layout
    :title="$t('My Travel')"
    :tabs="tabs"
    :containerFluid="true">
  </main-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import ViewAsAdminMixin from '@/lib/ViewAsAdminMixin';
import MyTravelInquiries from './MyTravelInquiries.vue';
import MyTravelReservation from './MyTravelReservation.vue';
import MyTravelHotelReservation from './MyTravelHotelReservation.vue';
import MyTravelPlans from './MyTravelPlans.vue';

export default {
  mixins: [ViewAsAdminMixin],
  mounted() {
    this.tabs.push({
      route: 'my-travel.reservations',
      name: 'Reservations',
      component: MyTravelReservation,
      title: 'Apartment Inquiries',
    });
    this.tabs.push(
      {
        route: 'my-travel.inquiries',
        name: 'Inquiries',
        component: MyTravelInquiries,
        title: 'Apartment Reservations',
      },
    );
    this.tabs.push({
      route: 'my-travel.hotel-reservations',
      name: 'Hotel Reservations',
      component: MyTravelHotelReservation,
      title: 'Hotel Reservations',
    });
    this.tabs.push({
      route: 'my-travel.travel-plans',
      name: 'My Trips',
      component: MyTravelPlans,
      title: 'My Trips',
    });
  },
  computed: {
    ...mapGetters(['user']),
  },
  data() {
    return {
      tabs: [],
    };
  },
};
</script>
